/* eslint-disable no-unused-vars */
import { useLocation, useNavigate } from "react-router-dom";

export const useQueryParams = (defaultParams = {}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get current query params (merged with defaults)
  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = { ...defaultParams }; // Start with defaults

    // Override defaults with actual URL values
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  };

  // Set query params (preserve defaults if not overridden)
  const setQueryParams = (newParams) => {
    const currentParams = new URLSearchParams(location.search);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") {
        currentParams.delete(key);
      } else {
        currentParams.set(key, String(value));
      }
    });

    navigate({ search: currentParams.toString() }, { replace: true });
  };

  // Get only non-empty params (excluding defaults if unused)
  const getNonEmptyQueryParams = () => {
    const params = getQueryParams();
    return Object.fromEntries(Object.entries(params).filter(([_, value]) => value !== undefined && value !== ""));
  };

  return {
    queryParams: getQueryParams(), // Merged with defaults
    setQueryParams,
    getNonEmptyQueryParams: getNonEmptyQueryParams(),
  };
};
